<div *ngIf="showTable && showData" class="main-div">
  <div class="table-div">
    <table aria-label="searched data" style="width: 100%;">
      <thead>
        <tr style="height: 38px">
          <th class="table-header" id="column" style="width: 10%">Procedure Code</th>
          <th class="table-header" id="column" style="width: 28%">
            Medical Policies or Clinical UM Guidelines
          </th>
          <th class="table-header" id="column" style="width: 30%">Recommended Documents</th>
          <th class="table-header" id="column" style="width: 17%">LOINC Code(s)</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of records; let i=index">
          <tr style="height: 40px">
            <td class="table-data" style="text-align: center">
              {{ item.procedurecode }}
            </td>
            <td class="table-data policy-data">
              <div class="tooltip" style="display: flex;">
                <div *ngFor="let label of item.policyNum; let val = index" class="policy-link-div">
                  <a
                    href={{item.policyLink[val]}}
                    target="_blank"
                    style="cursor: pointer;"
                    (mouseenter)="showPolicyToolTip(item.policyDesc[val])"
                    (mouseleave)="showTooltip = false"
                  >
                    {{ label }}
                  </a>
                </div>
                <div class="tooltiptext" *ngIf="showTooltip" style="width: 400px;">
                  <span>{{ policyDescription }}</span>
                </div>
              </div>
            </td>
            <td class="table-data">{{ item.prediction }}</td>
            <td class="table-data">
              <span
                class="tooltip"
                style="margin-right: 10px;"
                *ngFor="let code of item.loinccode"
                (mouseenter)="showPLoincToolTip(code, i)"
                (mouseleave)="showTooltip = false" 
              >
                {{ code }}
                <div class="tooltiptext" *ngIf="showTooltip">
                  <div>{{ loincDescription[0]?.loINCDescription }}</div>
                </div>
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <form class="feedback-div" [formGroup]="feedbackForm">
    <div style="display: flex; flex-direction: row">
      <p class="feedback-labels" style="margin-bottom: 4px">
        Was this tool helpful?
      </p>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="checkedOption" formControlName="ishelpful"> 
        <mat-radio-button class="radio-labels" value="Yes" role="radio" aria-label="feedback yes" [checked]="true">Yes</mat-radio-button>
        <mat-radio-button class="radio-labels" value="No" role="radio" aria-label="feedback no">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <p class="feedback-labels" style="margin-bottom: 4px">
        Please share your feedback and recommendations. (500 characters only)
      </p>
      <textarea
        class="textarea-style"
        maxlength="500"
        placeholder="Add a comment..."
        [(ngModel)]="commentAdded"
        formControlName="comment"
        [(ngModel)]="addedText"
        (keyup)="charactersCounter()"
      ></textarea>
      <div style="font-family: Lato; font-size: 14px;">
        <span id="wordCount">{{ characters }} </span>remaining.
      </div>
    </div>
    <button class="submit_button" aria-describedby="submit feedback" (click)="handleSubmit()">Submit</button>
  </form>
</div>

<app-loader *ngIf="isLoading"></app-loader>
